import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { LandingComponent } from '../landing/landing.component';
import { ErrorService } from './error.service';
import { AppService } from '../../app.service';
import { LandingService } from '../landing/landing.service';
import { HttpService } from '../../services/http.service';
import { AccessibilityService } from '../../services/accessibility.service';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { environment } from '../../../environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { UtilService } from './../../util.service';


@Component({
  selector: 'app-error',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  errorCodes = [];
  enableDisconnectWifiOption = false;
  accessiTranslate = { 'enterToCloseMsg': '' };
  private subscription: Subscription;
  public translationKey = ONBOARD_CONSTANTS.ERROR_TRALSALION_KEY;
  public messagesKey = ONBOARD_CONSTANTS.NOTIFICATION_TRALSALION_KEY;
  constructor(
    private errorService: ErrorService,
    private appService: AppService,
    private landingService: LandingService,
    private httpService: HttpService,
    private accessibilityService: AccessibilityService,
    private authService: AuthService,
    private utils: UtilService,
    private translate: TranslateService) {
    this.errorHandlingSubscribe();
  }

  ngOnInit() {
    this.checkEnvToEnableDisconnectWifi();
    this.loadAccessibilityTranslations();
  }

  /* Add Error from all components */
  private errorHandlingSubscribe() {
    this.subscription = this.errorService.resetErrorObservable.subscribe(
      errors => {
        this.errorCodes = [];
        if (errors.length > 0) {
          for (const error of errors) {
            this.errorCodes.push(this.updateErrorCodes(error));
          }
          this.accessibilityService.focus('#error-msg-0');
        }
        const unique = this.errorCodes.filter((v, i, a) => a.indexOf(v) === i);
        this.errorCodes = unique;
      });
  }

  updateErrorCodes(error) {
    let errorCodes: any;
    if (error.type && error.type === 'despOnly') {
      errorCodes = { 'type': 'error', 'desp': error.desp };
    } else if (error.type && error.type === 'keyOnly') {
      errorCodes = { 'type': 'info', 'transKey': error.translationKey };
    } else if (error.type && (error.type === 'infoerror' || error.type === 'notification')) {
      errorCodes = { 'type': error.type, 'errorCodeMessages': this.messagesKey + error.errorCode };
    } else if (error.type && error.type === 'info') {
      errorCodes = { 'type': error.type, 'desp': error.errorCode };
    } else {
      errorCodes = { 'type': 'error', 'errorCode': error.errorCode };
    }
    return errorCodes;
  }

  removeNotification(index) {
    this.errorCodes.splice(index, 1);
  }

  checkEnvToEnableDisconnectWifi() {
    if (environment.production === false) {
      this.enableDisconnectWifiOption = true;
    } else {
      this.enableDisconnectWifiOption = false;
    }
  }

  disconnectWifi() {
    this.appService.showLoader();
    this.errorService.removeError();
    const disconnectWIfiRequest = this.landingService.getDisconnectWifiRequest();
    this.httpService.postData(disconnectWIfiRequest).subscribe(
      disconnectWifiResponse => {
        if (disconnectWifiResponse.status.code === 'WLST') {
          LandingComponent.showLandingBanner = true;
          LandingComponent.disableConnectButton = false;
          this.appService.checkDeviceStatusAfterDisconnectWifi();
          this.landingService.showLandingBannerText();
          this.authService.logout();
          this.utils.newEBUserLogout();
        } else {
          this.errorService.addError(this.landingService.getDefaultError());
        }
        this.appService.hideLoader();
      },
      error => {
        this.errorService.addError(this.landingService.getDefaultError());
        this.appService.hideLoader();
      }
    )
  }

  // Accessibility Methods
  private loadAccessibilityTranslations() {
    this.translate.get(['closeButton', 'pressEnter', 'closeError']).subscribe(result => {
      const closeBtn = result['closeButton'] + '. ';
      this.accessiTranslate.enterToCloseMsg =  closeBtn + result['pressEnter'] + result['closeError'];
    });
  }
  public bookReferenceFocus(event) {
    event.preventDefault();
    this.accessibilityService.focus('#bookRef');
  }
}
